module.exports = __webpack_public_path__ + "img/ambassadorship.dfd6d8f2.png";